/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { TextField, YouTubeUrlField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { Button } from '@atoms';
import RichTextField from '@molecules/RichTextField';

import Form from '../Form';

import { FORM_FIELDS } from './constant';

const AddVideoForm = ({ onSubmit, visible }) => {
  const [form] = Form.useForm(FORM_FIELDS);

  const handleFinish = React.useCallback(
    (values) => {
      onSubmit(values);
      form.resetFields();
    },
    [form, onSubmit],
  );

  return (
    <Form form={form} onSerializedFinish={handleFinish} layout="vertical">
      <MediaField {...FORM_FIELDS.IMAGE} />
      <TextField {...FORM_FIELDS.TITLE} />
      <TextField {...FORM_FIELDS.TIME} />
      {visible && <RichTextField {...FORM_FIELDS.DESCRIPTION} />}
      <YouTubeUrlField {...FORM_FIELDS.VIDEO} />
      <Form.Item>
        <Button type="customBlue" onClick={form.submit}>
          ADD VIDEO
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddVideoForm;
